// extracted by mini-css-extract-plugin
export default {"service_card":"ServiceCard_service_card__rFa1f","service_card_actions":"ServiceCard_service_card_actions__JQWoZ"};